import { useQueryClient } from "@tanstack/react-query";
import { User } from "src/types/user";

// ----------------------------------------------------------------------

export default function useGetUser() {
	const queryClient = useQueryClient();
	return queryClient.getQueryData<User>(["user"])!;
}
